import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ProjectCommunicationService } from '../../../communication/project-comms.service';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../../helper/userpilot-reloader.component';
import { Alert } from '../../../models/helper/alerts-menu.model';

@Component({
  selector: 'app-alerts-menu',
  templateUrl: './alerts-menu.component.html',
  styleUrls: ['./alerts-menu.component.scss']
})
export class AlertsMenuComponent extends UserpilotReloader implements OnInit, OnDestroy {
  /**
   * Element ref object to the toggle button.
   */
  @ViewChild('toggleButton') toggleButton?: ElementRef;
  /**
   * Element ref object to the menu element.
   */
  @ViewChild('menu') menu?: ElementRef;
  /**
   * Notifier that emits when the component is destroyed.
   */
  onDestroyNotifier = new Subject<boolean>();
  /**
   * Boolean for if alerts are present.
   */
  hasAlerts = false;
  /**
   * Boolean for if there are new alerts.
   */
  newAlerts = false;
  /**
   * Array of alerts.
   */
  alertList: Alert[] = [];
  /**
   * Boolean for if the menu should be shown.
   */
  showMenu = false;

  /** trigger for translation pipe */
  trigger?: string;

  /**
   * Constructor: Sets up listener for renderer.
   * @param projectCommService
   * @param commService
   * @param renderer
   */
  constructor(private projectCommService: ProjectCommunicationService,
              private renderer: Renderer2,
              public translationService: AnessaTranslationService) {
    super();
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.toggleButton?.nativeElement.contains(e.target) &&
          this.menu && !this.menu.nativeElement.contains(e.target)) {
        this.showMenu = false;
      }
    });
  }

  /**
   * Sets up listener for results notifier and sets alert info when triggered.
   */
  // tslint:disable: forin
  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });

    this.projectCommService.resultsLoadedNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
          this.hasAlerts = false;
          this.alertList = [];
          // Don't show results errors on project input page
          if (this.projectCommService.isProjectInput()) {
            return;
          }
          const resultErrors = this.projectCommService.getResultErrors();
          if (!Array.isArray(resultErrors)) {
            // Backwards compatibility (old structure)
            if (resultErrors && Object.keys(resultErrors).length > 0) {
              for (const key in resultErrors) {
                this.alertList.push(resultErrors[key]);
                this.hasAlerts = true;
                this.newAlerts = true;
              }
              this.projectCommService.sendListToService(this.alertList)
              this.projectCommService.postToWarningsInfo();
            }
          } else {
            // New structure
            for (const error of resultErrors) {
              const params = {
                '%s': error['formatValues'],
              };
              this.alertList.push({ message: error['message'], params: params });
              this.hasAlerts = true;
              this.newAlerts = true;
            }
            this.projectCommService.sendListToService(this.alertList)
            this.projectCommService.postToWarningsInfo();
          }
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.next(true);
    this.onDestroyNotifier.unsubscribe();
  }

  /**
   * Sets the showMenu variable and resets the new alert flag.
   * @param val
   */
  toggleMenu(val: boolean) {
    this.showMenu = val;
    this.newAlerts = false;
  }
}
